
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-02750f7b&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./treatment.vue")
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-02750f7b&scoped=true!stylus-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./treatment.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./treatment.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-02750f7b!../../node_modules/vue-loader/lib/selector?type=template&index=0!./treatment.vue"),
  /* scopeId */
  "data-v-02750f7b",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/view/treatment.vue
// module id = 151
// module chunks = 2